import type { ReactNode } from 'react';

export const symbol_earbud_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M303-80q-24 0-42-18t-18-42v-351h-63q-24 0-42-18t-18-42v-189q0-24 18-42t42-18h394v60H180v189h93q12.75 0 21.38 8.62Q303-533.75 303-521v381h106v-381q0-12.75 8.63-21.38Q426.25-551 439-551h135v60H469v351q0 24-18 42t-42 18H303Zm468.17-398Q702.33-409 604-409q-12.75 0-21.37-8.63Q574-426.25 574-439v-411q0-12.75 8.63-21.38Q591.25-880 604-880q98.33 0 167.17 68.56Q840-742.88 840-644.94T771.17-478ZM738.5-755Q697-802 634-818v347q63-16 104.5-63.5T780-645q0-63-41.5-110ZM356-645Zm278 0Z"
		/>
	</svg>
);
